import React, { useCallback, useEffect, useState } from 'react'
import ConfirmationModal from '../../../Modals/ConfirmationModal'
import ActionButton from '../../../../elemets/ActionButton'
import { isMobile } from '../../../../utils/common'
import { createUseStyles } from 'react-jss'
import CustomInput from '../../../../elemets/CustomInput'
import { useApiSubmit } from '../../../../api'
import compose from 'just-compose'
import { withErrorHandler } from '../../../../errors'

const useStyles = createUseStyles({
  dialogMobile: {
    margin: 0,
    '& .modal-content': {
      borderRadius: 0,
    },
  },
  inputContainerStyle: {
    marginBottom: 10,
    '& label': {
      color: '#797575',
    },
  },
})

const AddUserModal = ({ group, setDisplayModal, reload, handleError }) => {
  const classes = useStyles()
  const [formState, setFormState] = useState({
    firstName: '',
    lastName: '',
    email: '',
  })

  const {
    submitted,
    submit: addProfile,
    err: updateErr,
    submitting,
  } = useApiSubmit('addGroupMember')

  const handleInput = useCallback(e => {
    const value = e.target.value
    const name = e.target.name
    setFormState(f => ({
      ...f,
      [name]: value,
    }))
  }, [])

  useEffect(() => {
    if (submitted && !updateErr && !submitting) {
      setDisplayModal(false)
      reload()
    } else if (updateErr && !submitting) {
      handleError(updateErr, true, {
        message: 'There was a problem adding your profile.',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitted, updateErr, submitting])

  const save = useCallback(() => {
    addProfile({
      params: {
        groupId: group.id,
      },
      body: {
        ...formState,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formState, group])

  return (
    <ConfirmationModal
      show={true}
      onClose={() => setDisplayModal(false)}
      closeIcon={true}
      title={'Add User'}
      content={
        <div className={classes.content}>
          <CustomInput
            containerStyle={classes.inputContainerStyle}
            name="firstName"
            value={formState.firstName}
            onChange={handleInput}
            title="First Name"
          />
          <CustomInput
            containerStyle={classes.inputContainerStyle}
            name="lastName"
            value={formState.lastName}
            onChange={handleInput}
            title="Last Name"
          />
          <CustomInput
            containerStyle={classes.inputContainerStyle}
            name="email"
            value={formState.email}
            onChange={handleInput}
            title="Email"
          />
        </div>
      }
      footer={
        <div className="d-flex justify-content-end">
          <ActionButton
            text="ADD USER"
            className="w-40"
            onClick={save}
            type="STRONG_GREEN"
          />
        </div>
      }
      dialogClassName={isMobile() ? classes.dialogMobile : ''}
    />
  )
}

export default compose(withErrorHandler)(AddUserModal)
